
import { computed, defineComponent, PropType } from 'vue';

export default defineComponent({
  props: {
    data: {
      type: Array as PropType<any[]>,
      default: () => [],
    },
  },
  setup(props) {
    const tableData = computed(() => props.data ?? []);
    return {
      tableData,
    };
  },
});
